"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceCalculator = exports.UNIT_PRICE_PRECISION = void 0;
const dinero = __importStar(require("dinero.js"));
const currencies_1 = require("../consts/currencies");
const currency_enum_1 = require("../models/common/currency.enum");
const common_1 = require("./common");
exports.UNIT_PRICE_PRECISION = 6;
class PriceCalculator {
    constructor(currency) {
        var _a, _b;
        this.precision = ((_a = currencies_1.Currencies[currency]) === null || _a === void 0 ? void 0 : _a.decimal_digits) || ((_b = currencies_1.Currencies[currency_enum_1.CurrencyEnum.EUR]) === null || _b === void 0 ? void 0 : _b.decimal_digits);
        this.currency = currency;
    }
    toRoundedAmount(dinero) {
        return dinero.toRoundedUnit(this.precision);
    }
    roundToPrecision(amount, roundingPrecision = exports.UNIT_PRICE_PRECISION) {
        if (roundingPrecision < 0) {
            throw new Error(`IllegalArgument: roundingPrecision=${roundingPrecision} cannot be less than 0`);
        }
        const currencyMultiplier = Math.pow(10, roundingPrecision);
        const amountToUse = Math.round(amount * currencyMultiplier);
        return dinero.default({ amount: amountToUse, currency: this.currency, precision: roundingPrecision }).toRoundedUnit(roundingPrecision);
    }
    totalsFromUnitPriceAndQuantity(input) {
        const { unitPrice, quantity, taxRate = 0 } = input;
        const totalNetPriceDinero = (0, common_1.toDinero)(unitPrice * quantity);
        const totalTaxPriceDinero = totalNetPriceDinero.multiply(taxRate / 100);
        const totalGrossPriceDinero = totalNetPriceDinero.add(totalTaxPriceDinero);
        return {
            totalNetPrice: this.toRoundedAmount(totalNetPriceDinero),
            totalTaxPrice: this.toRoundedAmount(totalTaxPriceDinero),
            totalGrossPrice: this.toRoundedAmount(totalGrossPriceDinero),
        };
    }
    totalsFromGrossPrice(input) {
        const { totalGrossPrice, taxRate = 0 } = input;
        const totalGrossPriceDinero = (0, common_1.toDinero)(totalGrossPrice);
        const totalNetPriceDinero = totalGrossPriceDinero.divide(1 + taxRate / 100);
        const totalTaxPriceDinero = totalGrossPriceDinero.subtract(totalNetPriceDinero);
        return {
            totalNetPrice: this.toRoundedAmount(totalNetPriceDinero),
            totalTaxPrice: this.toRoundedAmount(totalTaxPriceDinero),
            totalGrossPrice: this.toRoundedAmount(totalGrossPriceDinero),
        };
    }
    totalsFromNetPrice(input) {
        const { totalNetPrice, taxRate = 0 } = input;
        const totalNetPriceDinero = (0, common_1.toDinero)(totalNetPrice);
        const totalTaxPriceDinero = totalNetPriceDinero.multiply(taxRate / 100);
        const totalGrossPriceDinero = totalNetPriceDinero.add(totalTaxPriceDinero);
        return {
            totalNetPrice: this.toRoundedAmount(totalNetPriceDinero),
            totalTaxPrice: this.toRoundedAmount(totalTaxPriceDinero),
            totalGrossPrice: this.toRoundedAmount(totalGrossPriceDinero),
        };
    }
    totalsFromNetPriceAndTaxPrice(input) {
        const { totalNetPrice, totalTaxPrice } = input;
        const totalNetPriceDinero = (0, common_1.toDinero)(totalNetPrice);
        const totalTaxPriceDinero = (0, common_1.toDinero)(totalTaxPrice);
        const totalGrossPriceDinero = totalNetPriceDinero.add(totalTaxPriceDinero);
        return {
            totalNetPrice: this.toRoundedAmount(totalNetPriceDinero),
            totalTaxPrice: this.toRoundedAmount(totalTaxPriceDinero),
            totalGrossPrice: this.toRoundedAmount(totalGrossPriceDinero),
        };
    }
    taxPriceFromGrossAndNetPrice(input) {
        const { totalGrossPrice, totalNetPrice } = input;
        const totalGrossPriceDinero = (0, common_1.toDinero)(totalGrossPrice);
        const totalNetPriceDinero = (0, common_1.toDinero)(totalNetPrice);
        const totalTaxPriceDinero = totalGrossPriceDinero.subtract(totalNetPriceDinero);
        return {
            totalTaxPrice: this.toRoundedAmount(totalTaxPriceDinero),
        };
    }
    unitPriceFromNetPriceAndQuantity(input) {
        const { totalNetPrice, quantity } = input;
        if (quantity === 0) {
            if (totalNetPrice !== 0) {
                throw new Error(`IllegalArgument: quantity=${quantity} and totalNetPrice=${totalNetPrice}. Cannot divide by zero.`);
            }
            // if quantity is 0 and totalNetPrice is 0, return 0
            return {
                unitPrice: 0,
            };
        }
        return {
            unitPrice: this.roundToPrecision(totalNetPrice / quantity, exports.UNIT_PRICE_PRECISION),
        };
    }
    priceInference(input) {
        const { unitPrice, quantity, taxRate, totalPrice } = input;
        // Scenario 1: unitPrice and quantity provided
        if (unitPrice != null && quantity != null) {
            const { totalNetPrice, totalTaxPrice, totalGrossPrice } = this.totalsFromUnitPriceAndQuantity({
                unitPrice,
                quantity,
                taxRate: taxRate !== null && taxRate !== void 0 ? taxRate : 0,
            });
            return {
                unitPrice: this.roundToPrecision(unitPrice, exports.UNIT_PRICE_PRECISION),
                totalNetPrice,
                totalTaxPrice,
                totalGrossPrice,
            };
        }
        // Scenario 2: totalPrice provided
        if (totalPrice != null) {
            const isItemTotalGross = taxRate != null && taxRate > 0;
            if (isItemTotalGross) {
                const { totalNetPrice, totalTaxPrice, totalGrossPrice } = this.totalsFromGrossPrice({
                    totalGrossPrice: totalPrice,
                    taxRate: taxRate !== null && taxRate !== void 0 ? taxRate : 0,
                });
                let calculatedUnitPrice;
                if (quantity != null) {
                    const { unitPrice: unitPriceResult } = this.unitPriceFromNetPriceAndQuantity({
                        totalNetPrice,
                        quantity,
                    });
                    calculatedUnitPrice = unitPriceResult;
                }
                return {
                    unitPrice: calculatedUnitPrice,
                    totalNetPrice,
                    totalTaxPrice,
                    totalGrossPrice,
                };
            }
            // totalPrice is totalNetPrice
            const { totalNetPrice, totalTaxPrice, totalGrossPrice } = this.totalsFromNetPrice({
                totalNetPrice: totalPrice,
                taxRate: taxRate !== null && taxRate !== void 0 ? taxRate : 0,
            });
            let calculatedUnitPrice;
            if (quantity != null) {
                const { unitPrice: unitPriceResult } = this.unitPriceFromNetPriceAndQuantity({
                    totalNetPrice,
                    quantity,
                });
                calculatedUnitPrice = unitPriceResult;
            }
            return {
                unitPrice: calculatedUnitPrice,
                totalNetPrice,
                totalTaxPrice,
                totalGrossPrice,
            };
        }
        // Scenario 3: fallback - no valid price data
        return {
            unitPrice: unitPrice != null ? this.roundToPrecision(unitPrice, exports.UNIT_PRICE_PRECISION) : undefined,
            totalNetPrice: this.toRoundedAmount((0, common_1.toDinero)(totalPrice !== null && totalPrice !== void 0 ? totalPrice : 0)),
            totalTaxPrice: 0,
            totalGrossPrice: this.toRoundedAmount((0, common_1.toDinero)(totalPrice !== null && totalPrice !== void 0 ? totalPrice : 0)),
        };
    }
}
exports.PriceCalculator = PriceCalculator;
